export default __webpack_public_path__ + "static/motion2-463989c1f98e8675dc70ac391570fe9c.png";